<template>
  <div class="wrapper">
    <el-image class="title" :src="require('@/assets/home/all_win_title.png')"></el-image>
    <div class="content">
      <div class="classify">
        <div class="c-item" :class="currentClassifyId == v.classifyId?'act':''" v-for="(v,i) in classifyList" :key="i"
             @click="classifySelect(v)">
          <div class="name">{{ v.name }}</div>
          <div class="line"></div>
        </div>
      </div>
      <div class="c-main">
        <el-form ref="form" :model="form" :rules="rules" label-width="100px">
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item label="公司名称:" prop="companyName">
                <el-input v-model="form.companyName" placeholder="请输入公司名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系人:" prop="user">
                <el-input v-model="form.user" placeholder="请输入联系人"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item label="电话:" prop="phone">
                <el-input v-model="form.phone" placeholder="请输入电话"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="所在地区:" prop="area">
                <area-select v-model="form.area" placeholder="请选择加盟地区"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item class="btn-item">
            <el-button type="primary" :loading="loading > 0" @click="submit">
              {{ ['立即提交','提交中...','提交成功'][loading]}}
            </el-button>
          </el-form-item>
        </el-form>
        <div class="tip"><span>*</span>提交后客服将和您联系，或者直接联系<a href="tel:400-9999-114">400-9999-114</a></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AllWin",
  data() {
    return {
      classifyList: [
        {
          classifyId: 1,
          name: '我要检测'
        },
        {
          classifyId: 2,
          name: '我要认证'
        },
        {
          classifyId: 3,
          name: '我要考证'
        },
        {
          classifyId: 4,
          name: '我要加盟'
        },
        {
          classifyId: 5,
          name: '购买仪器'
        },
        {
          classifyId: 6,
          name: '异业合作'
        }
      ],
      currentClassifyId: 1,
      form: {
        companyName: '',
        user: '',
        phone: '',
        area: []
      },
      rules: {
        companyName: [
          {
            required: true,
            message: '请输入公司名称',
            trigger: 'blur'
          }
        ],
        user: [
          {
            required: true,
            message: '请输入联系人',
            trigger: 'blur'
          }
        ],
        phone: [
          {
            required: true,
            message: '请输入电话',
            trigger: 'blur'
          }
        ],
        area: [
          {
            required: true,
            type: 'array',
            message: '请选择加盟地区',
            trigger: 'blur'
          }
        ]
      },
      loading: 0
    }
  },
  methods: {
    /**
     * 立即提交
     */
    submit() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return false
        }
        this.loading = 1
        const data = {
          ...this.form,
          classifyId: this.currentClassifyId
        }
        this.$request.post('/Home/allWin', data)
            .then(res => {
              if (res.code === 0) {
                this.form = {
                  companyName: '',
                  user: '',
                  phone: '',
                  area: []
                }
                // this.$message.success(res.message)

                this.$notify({
                  title: '提示信息',
                  dangerouslyUseHTMLString: true,
                  message: `<div style="color: #1e90ff;font-weight: bold;">${res.message}</div>`,
                  type: 'success',
                  position: 'bottom-right'
                });
              }
              this.loading = 2

              setTimeout(() => {
                this.loading = 0
              }, 1000)
            })
            .catch(e => {
              setTimeout(() => {
                this.loading = 0
              }, 1000)
            })
      })
    },
    /**
     * 分类选择
     * @param classifyId
     */
    classifySelect({classifyId}) {
      this.currentClassifyId = classifyId
    }
  }
}
</script>

<style scoped lang="scss">
.wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  .title {
    width: 367px;
    height: 55px;
  }

  .content {
    margin-top: 77px;
    display: flex;
    flex-direction: column;
    width: 100%;

    .classify {
      display: flex;
      flex-direction: row;
      align-items: center;
      border-bottom: 1px solid #D7D7D7;

      .c-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        cursor: pointer;
        margin-right: 55px;

        &:first-child {
          margin-left: 25px;
        }

        &.act {
          .name {
            color: #2D2D2D;
          }

          .line {
            opacity: 1;
          }
        }

        .name {
          color: #6C6C6C;
          font-size: 20px;
          font-weight: bold;
        }

        .line {
          width: 80px;
          height: 6px;
          background-color: #1464FF;
          border-radius: 8px;
          opacity: 0;
        }
      }
    }

    .c-main {
      margin-top: 40px;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;

      .tip {
        display: flex;
        flex-direction: row;
        color: #A4A4A4;
        font-weight: bold;
        font-size: 14px;
        margin-top: 10px;
        align-items: center;

        span {
          color: #FF3E4A;
        }
        a {
          color: #A4A4A4;
          text-decoration: none;
          margin-left: 2px;
        }
      }

      ::v-deep {
        .el-form {
          width: 100%;

          .el-form-item__label {
            color: #000000;
            font-size: 14px;
            font-weight: bold;
          }

          .el-input__inner {
            background-color: #F5F6F8;
          }

          .btn-item {
            margin-top: 20px;

            .el-form-item__content {
              margin-left: 0;
              text-align: center;

              .el-button {
                width: 256px;
                background-color: #1464FF;
              }
            }
          }
        }
      }
    }
  }
}
</style>